import React, { PureComponent } from 'react'
import {
  func, bool, shape, string,
} from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import { noop } from '../../../../shared/utils/commonUtils'
import PasswordContent from '../../../common/PasswordContent'

import './PasswordUpdater.scss'

class PasswordUpdater extends PureComponent {
  static propTypes = {
    isPasswordUpdaterShow: bool.isRequired,
    isForceRequireAction: bool,
    handlePasswordUpdaterModalClose: func.isRequired,
    handlePasswordUpdaterSubmit: func.isRequired,
    passwordUpdaterResult: shape({
      code: string,
      message: string,
    }),
    username: string,
  }

  static defaultProps = {
    passwordUpdaterResult: {
      code: null,
      message: null,
    },
    username: '',
    isForceRequireAction: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      fields: { newPswd: '' },
      cleanPswd: noop,
    }
  }

  onClose = () => {
    const { isForceRequireAction, handlePasswordUpdaterModalClose } = this.props
    if (!isForceRequireAction) {
      this.resetPswd()
      handlePasswordUpdaterModalClose()
    }
  }

  resetPswd = () => {
    const { cleanPswd } = this.state
    this.setState({
      fields: { newPswd: '' },
    })
    cleanPswd()
  }

  initCleanPswd = cleanPswd => {
    this.setState({
      cleanPswd,
    })
  }

  render() {
    const {
      isPasswordUpdaterShow, handlePasswordUpdaterSubmit, passwordUpdaterResult: { code, message }, username,
    } = this.props

    const { fields } = this.state
    return (
      <Modal
        autoFocusClose
        shown={isPasswordUpdaterShow}
        onClose={this.onClose}
        className="passport-ui-app__modal passport__password-updater action_required"
        size="md"
      >
        <PasswordContent
          handlePasswordContentSubmit={handlePasswordUpdaterSubmit}
          showError={!!code}
          message={message}
          username={username}
          initCleanPswd={this.initCleanPswd}
          fields={fields}
          Body={ModalBody}
          Footer={ModalFooter}
        />
      </Modal>
    )
  }
}

export default PasswordUpdater
